import React, { useState, useRef, useLayoutEffect } from "react";
import styles from './Tooltip.module.less';
export function Tooltip({ target, content }) {
    const ref = useRef(null);
    const [pos, setPos] = useState({ x: 0, y: 0 });
    useLayoutEffect(() => {
        if (target && ref.current) {
            const rect = target.getBoundingClientRect();
            const { width, height } = ref.current.getBoundingClientRect();
            const { clientWidth, clientHeight } = document.documentElement;
            let x = rect.left - (width - rect.width) / 2;
            if (x + width > clientWidth) {
                x -= x + width - clientWidth;
            }
            x = Math.max(0, x);
            let y = rect.top - height - 2;
            if (y < 0) {
                y = rect.bottom + 2;
            }
            setPos({ x, y });
        }
    }, []);
    return (content.length &&
        React.createElement("div", { ref: ref, className: styles.tooltip, style: { left: pos.x, top: pos.y }, dangerouslySetInnerHTML: { __html: content } }));
}
